export default __webpack_public_path__ + "static/webRotator/svg/47c613c3ebeffe6b932c92743a4fd685.svg";